/**
 * Volta Financial Service
 * Volta is the Oi Soft ERP
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * {    \"Pending\": \"Pending\",    \"Started\": \"Started\",    \"WithErrors\": \"Failed\",    \"Completed\": \"Completed\",    \"Requested\": \"Requested\"  }
 */
export type ProcessRunnerProcessStatusEnum = 'Pending' | 'Started' | 'WithErrors' | 'Completed' | 'Requested';

export const ProcessRunnerProcessStatusEnum = {
    Pending: 'Pending' as ProcessRunnerProcessStatusEnum,
    Started: 'Started' as ProcessRunnerProcessStatusEnum,
    WithErrors: 'WithErrors' as ProcessRunnerProcessStatusEnum,
    Completed: 'Completed' as ProcessRunnerProcessStatusEnum,
    Requested: 'Requested' as ProcessRunnerProcessStatusEnum
};